import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import MoldRemediationPage from "./pages/MoldRemediationPage";
import MoldSubservicePage from "./pages/MoldSubservicePage";
import ContactPage from "./pages/ContactPage";
import GalleryPage from "./pages/GalleryPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPage from "./pages/BlogPage";
import GuidesListPage from "./pages/GuidesListPage";
import GuidePage from "./pages/GuidePage";
import CityServicePage from "./pages/CityServicePage";
import AdminLeadsPage from "./pages/AdminLeadsPage";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFoundPage from "./pages/NotFoundPage";
import ExitIntentPopup from "./components/ExitIntentPopup";
import { initAttribution } from "./utils/attribution";

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Attribution initializer component
const AttributionInit = () => {
  useEffect(() => {
    initAttribution();
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AttributionInit />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="services" element={<ServicesPage />} />
              {/* Dedicated mold remediation page with enhanced content */}
              <Route path="services/mold-remediation" element={<MoldRemediationPage />} />
              {/* 301 Redirect: Dallas mold page to main mold page (URL consolidation) */}
              <Route path="services/mold-remediation/dallas" element={<Navigate to="/services/mold-remediation" replace />} />
              {/* Mold subservice pages (black mold, attic mold, etc.) */}
              <Route path="services/mold-remediation/:subserviceSlug" element={<MoldSubservicePage />} />
              <Route path="services/:serviceId" element={<ServiceDetailPage />} />
              <Route path="services/:serviceId/:city" element={<CityServicePage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="blog" element={<BlogListPage />} />
              <Route path="blog/:slug" element={<BlogPage />} />
              {/* Mold Guides - Supporting Content Cluster */}
              <Route path="guides" element={<GuidesListPage />} />
              <Route path="guides/:slug" element={<GuidePage />} />
              {/* 404 catch-all */}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            {/* Admin routes - no layout wrapper */}
            <Route path="admin/login" element={<LoginPage />} />
            <Route
              path="admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeadsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <ExitIntentPopup />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
